/* eslint-disable no-bitwise */
import { fileTypeEnum } from 'modules/common/enums';

export const checkIfAPIResponseIsSuccess = responseCode =>
  responseCode >= 200 && responseCode < 300;

const dataURItoBlob = dataURI => {
  const mimeType = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const byteString = atob(dataURI.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i += 1) {
    intArray[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([arrayBuffer], { type: mimeType });
  return blob;
};

export const convertFileToBlob = fileData =>
  new Promise(resolve => {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        const blob = dataURItoBlob(reader.result);
        resolve(blob);
      },
      false,
    );

    reader.readAsDataURL(fileData);
  });

export const generateUUID = () => {
  let d = new Date().getTime();
  // eslint-disable-next-line max-len
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const trimText = (text, charactersToAppear, appendDots = true) => {
  if (!text) return '';

  if (text.length <= charactersToAppear) return text;

  const trimmedText = text.substr(0, charactersToAppear);
  return (appendDots && `${trimmedText}...`) || trimmedText;
};

export const detectFileTypeFromExtension = fileExtension => {
  if (/pdf/.test(fileExtension)) return fileTypeEnum.pdf;

  return fileTypeEnum.image;
};
